var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 57,
    viewBox: "0 0 55 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7956_50796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0431 56.0449L28.0397 56.0474C27.8564 56.1821 27.6758 56.3148 27.4984 56.4453C27.321 56.3148 27.1405 56.1821 26.9571 56.0474L26.9537 56.0449C25.7015 55.1249 24.3131 54.1046 22.8445 52.9569C25.8107 51.1599 28.9006 48.9853 31.8919 46.2954L32.3032 45.9255C35.0509 43.4924 37.8257 40.6201 40.3133 37.1097C44.9189 30.6105 48.6505 21.7196 48.586 9.17323L48.583 8.58355L48.0113 8.43552C40.6461 6.5282 31.8409 5.75709 27.5211 5.6298L27.4984 5.62913L27.4758 5.6298C23.156 5.75709 14.3508 6.5282 6.98553 8.43552L6.41389 8.58355L6.41085 9.17323C6.34636 21.7196 10.0779 30.6105 14.6836 37.1097C16.6334 39.8611 18.7595 42.2206 20.9109 44.2839C19.3383 45.3591 17.7647 46.3111 16.2195 47.1701C7.84219 38.8525 -0.353528 25.9314 1.05791 4.79399C9.90031 1.64991 22.2664 0.582936 27.4907 0.445514L27.4984 0.445312L27.5059 0.445509C32.7302 0.58293 45.0965 1.64991 53.9389 4.79399C55.024 21.0429 50.432 32.4223 44.4665 40.5845C40.3017 46.2828 35.4515 50.4345 31.337 53.5877C30.1683 54.4834 29.061 55.297 28.0431 56.0449Z",
    fill: "#17EB79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2637 16.6121C43.4541 16.8205 43.4391 17.1436 43.2304 17.3337L24.7353 34.172C24.5297 34.3593 24.2118 34.3479 24.02 34.1465L15.5744 25.2772C15.3797 25.0727 15.3879 24.7494 15.5926 24.555L18.5583 21.7393C18.7631 21.5449 19.0869 21.5531 19.2815 21.7575L24.2753 27.0018C24.4671 27.2032 24.7849 27.2146 24.9906 27.0273L39.7839 13.5592C39.9926 13.3691 40.3162 13.384 40.5065 13.5925L43.2637 16.6121Z",
    fill: "#17EB79"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7956_50796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b5fbcc634a3c1b189c8fe10ac576e2be.svg";
export { ForwardRef as ReactComponent };